import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

const CMSOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0, limit: 20 });
  const [filterStatus, setFilterStatus] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadOrders();
  }, [page, filterStatus]);

  const loadOrders = async () => {
    try {
      setLoading(true);
      setError('');
      const params = { page, limit: 20 };
      if (filterStatus) params.status = filterStatus;
      if (search) params.search = search;
      const res = await api.getEcommerceOrders(params);
      if (res.success) {
        setOrders(res.data || []);
        setPagination(res.pagination || { page: 1, pages: 1, total: 0, limit: 20 });
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    loadOrders();
  };

  return (
    <>
      {error && (
        <div className="alert alert-danger alert-dismissible">
          <button type="button" className="close" onClick={() => setError('')}>&times;</button>
          {error}
        </div>
      )}

      <div className="card card-outline card-primary mb-3">
        <div className="card-header">
          <h3 className="card-title">Filters</h3>
        </div>
        <div className="card-body">
          <form onSubmit={handleSearch} className="form-inline flex-wrap">
            <input
              type="text"
              className="form-control form-control-sm mr-2 mb-1"
              placeholder="Order #, customer name or email"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <select
              className="form-control form-control-sm mr-2 mb-1"
              value={filterStatus}
              onChange={(e) => { setFilterStatus(e.target.value); setPage(1); }}
            >
              <option value="">All statuses</option>
              <option value="pending">Pending</option>
              <option value="confirmed">Confirmed</option>
              <option value="shipped">Shipped</option>
              <option value="delivered">Delivered</option>
              <option value="cancelled">Cancelled</option>
            </select>
            <button type="submit" className="btn btn-sm btn-primary mb-1">
              <i className="fas fa-search"></i> Search
            </button>
          </form>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Orders</h3>
          <div className="card-tools">
            <span className="text-muted small">Read-only (checkout in Phase 2)</span>
          </div>
        </div>
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center p-4">Loading...</div>
          ) : (
            <table className="table table-bordered table-hover mb-0">
              <thead>
                <tr>
                  <th>Order #</th>
                  <th>Customer</th>
                  <th>Email</th>
                  <th>Total</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th style={{ width: 80 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {orders.length > 0 ? (
                  orders.map((o) => (
                    <tr key={o.id}>
                      <td><code>{o.order_number}</code></td>
                      <td>{o.customer_name}</td>
                      <td>{o.customer_email}</td>
                      <td>{Number(o.total).toFixed(2)}</td>
                      <td>
                        <span className="badge bg-secondary">{o.status}</span>
                      </td>
                      <td>{o.created_at ? new Date(o.created_at).toLocaleString() : '—'}</td>
                      <td>
                        <Link to={`/cms/orders/${o.id}`} className="btn btn-sm btn-info">
                          <i className="fas fa-eye"></i>
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">No orders found</td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        {pagination.pages > 1 && (
          <div className="card-footer clearfix">
            <span className="text-muted">
              Page {pagination.page} of {pagination.pages} ({pagination.total} total)
            </span>
            <ul className="pagination pagination-sm m-0 float-right">
              <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
                <button type="button" className="page-link" onClick={() => setPage((p) => Math.max(1, p - 1))}>«</button>
              </li>
              <li className={`page-item ${page >= pagination.pages ? 'disabled' : ''}`}>
                <button type="button" className="page-link" onClick={() => setPage((p) => Math.min(pagination.pages, p + 1))}>»</button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </>
  );
};

export default CMSOrders;
